module.exports = __webpack_public_path__ + "img/3.4.1.a128cedf.png";